import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskGovernanceOverviewStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(2),
            flex: 1,
        },
        statRow: {
            display: "grid",
            gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(5, 1fr)" },
            gap: theme.spacing(2),
        },
        statRowWithExposure: {
            gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(6, 1fr)" },
        },
        statNumber: {
            fontSize: "2rem",
            fontWeight: theme.typography.fontWeightLight,
            color: theme.palette.primary.dark,
            lineHeight: 1,
        },
        statNumberDanger: {
            color: theme.palette.error.main,
        },
        statSubLabel: {
            fontSize: "0.75rem",
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.primary.dark,
        },
        // The surrounding DotLegalLink underlines in its own (blue) link color on hover, which clashes with
        // the red text; the link's underline is disabled and recreated here so it inherits the red.
        gapLink: {
            fontSize: "0.75rem",
            fontWeight: theme.typography.fontWeightRegular,
            color: theme.palette.error.main,
            "&:hover": {
                textDecoration: "underline",
            },
        },
        // A clickable headline number: same trick as gapLink — the DotLegalLink's own (blue) hover underline is
        // disabled and recreated here so it inherits the number's colour.
        statNumberLink: {
            "&:hover": {
                textDecoration: "underline",
            },
        },
        mainColumns: {
            display: "grid",
            gridTemplateColumns: { xs: "1fr", lg: "minmax(0, 1.2fr) minmax(0, 1fr)" },
            gap: theme.spacing(2),
            alignItems: "stretch",
        },
        cardHeaderRow: {
            display: "flex",
            alignItems: "baseline",
            gap: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        // The DotLegalEmptyState is height:100%. Inside this page's flex:1 column shell the paper gets a
        // definite (squeezed) height, so the empty state would consume the whole content box and push the
        // header/clear button out via overflow. An auto-height wrapper collapses the 100% to the
        // illustration's natural size, keeping every child inside the paper.
        cellEmptyStateWrapper: {
            display: "flex",
            justifyContent: "center",
        },
        clearFilterRow: {
            display: "flex",
            justifyContent: "flex-start",
            marginTop: theme.spacing(2),
        },
        emptyText: {
            color: theme.palette.text.secondary,
            fontStyle: "italic",
            paddingY: theme.spacing(2),
        },
    });
};
